//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { useEffect } from 'react';

import { CAPTIONS_STATUS_VALUE } from 'app/constants/mute-tooltip-content';

export const useCaptionStatus = (
  captionTurnOnOffState: string,
  captionStatusValue: string | undefined,
  setCaptionStatus: (val: boolean) => void,
) => {
  useEffect(() => {
    const isCaptioned: boolean =
      captionTurnOnOffState === 'on' &&
      captionStatusValue === CAPTIONS_STATUS_VALUE.SUCCEEDED;

    if (isCaptioned) {
      setCaptionStatus(isCaptioned);
    }
  }, [captionTurnOnOffState, captionStatusValue, setCaptionStatus]);
};
